<template>
  <el-tabs type="border-card">
    <el-tab-pane label="产品类型">
      <productType ref="productType" />
    </el-tab-pane>
    <el-tab-pane label="产品系列">
      <productSet ref="productSet" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import productSet from "./productSet";
import productType from "./productType";
export default {
  components: {
    productSet,
    productType,
  },
  data() {
    return {};
  },
  methods: {

  },
  mounted() {

  },
};
</script>
